import { render, staticRenderFns } from "./OrderLoading.vue?vue&type=template&id=6adc87c6&scoped=true&"
import script from "./OrderLoading.vue?vue&type=script&lang=ts&"
export * from "./OrderLoading.vue?vue&type=script&lang=ts&"
import style0 from "./OrderLoading.vue?vue&type=style&index=0&id=6adc87c6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adc87c6",
  null
  
)

export default component.exports